import React, { useRef, useEffect, useState } from 'react';

interface CursorGlowProps {
  containerRef?: React.RefObject<HTMLDivElement>;
}

export const CursorGlow: React.FC<CursorGlowProps> = ({ containerRef }) => {
  const glowRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const rafRef = useRef<number>(0);
  const posRef = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const container = containerRef?.current || glowRef.current?.parentElement;
    if (!container) return;

    const handlePointerMove = (e: PointerEvent) => {
      const rect = container.getBoundingClientRect();
      posRef.current = {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
      };
      
      setVisible(true);

      cancelAnimationFrame(rafRef.current);
      rafRef.current = requestAnimationFrame(() => {
        if (glowRef.current) {
          glowRef.current.style.transform = `translate3d(${posRef.current.x}px, ${posRef.current.y}px, 0) translate(-50%, -50%)`;
        }
      });
    };

    const handlePointerLeave = () => {
      setVisible(false);
    };

    container.addEventListener('pointermove', handlePointerMove);
    container.addEventListener('pointerleave', handlePointerLeave);

    return () => {
      container.removeEventListener('pointermove', handlePointerMove);
      container.removeEventListener('pointerleave', handlePointerLeave);
      cancelAnimationFrame(rafRef.current);
    };
  }, [containerRef]);

  return (
    <div
      ref={glowRef}
      className="cursor-glow"
      style={{
        opacity: visible ? 1 : 0,
        left: 0,
        top: 0,
      }}
    />
  );
};

export default CursorGlow;

